<template>
    <div>
        <SafetyInfoWin v-show="false" :wrap-class="'simple_popup_wrap'" v-on:loaded-safety-info="loadedSimplemapInfoHandle" ref="safetyInfoWin" />
        <AccidentInfoWin v-show="false" :wrap-class="'simple_popup_wrap'" v-on:loaded-accident-info="loadedSimplemapInfoHandle" ref="accidentInfoWin" />
    </div>
</template>

<script>
import gripUtil from "@/libs/grip.util";
import airLevel from "@/libs/air.level.js";
import { mapGetters } from "vuex";
import { $_TYPE, $_WC, $_ADM, $_NM } from '@/confs/common.const';
import simpleMapMixins from '@/stores/simple.map.mixin';
import naverMapUtil from '@/libs/grip.naver.map.util';
import SafetyInfoWin from '@/views/realtime/SafetyInfoWin.vue';
import AccidentInfoWin from '@/views/realtime/AccidentInfoWin.vue';
import NaverMapMixin from '@/stores/naver.map.share.mixin.js';
import gripSimpleMapMixins from '@/stores/grip.simplemap.mixin.js';

export default {
    name: "SimplemapCtrl",
    data(){
        return {
            groupName: 'mainChart',
            boxChartMaxVal: 5,
            boxChartSize: 5,
            boxChartColors: ['#e57373', '#e5b87d', '#92dd92', '#91defa'],
            safetyMarkerGroupKey: 'Safety',
            accidentMarkerGroupKey: 'Accident',
        };
    },
    components: {
        SafetyInfoWin,
        AccidentInfoWin,
    },
    watch: {
        selectedRealtimeTab: {
            immediate: false,
            handler: function(newVal, oldVal) {
                if(typeof this.simpleMap !== $_TYPE.UNDEF) {
                    if(typeof this['show' + newVal + 'Chart'] === 'function') {
                        this['show' + newVal + 'Chart']();
                    }
                }
            }
        },
        selectedRealtimeSubTab: {
            immediate: false,
            handler: function(newVal, oldVal) {
                if(typeof this.simpleMap !== $_TYPE.UNDEF) {
                    if(this.selectedRealtimeTab === 'Air') {
                        this.showAirChart();
                    } else if(this.selectedRealtimeTab === 'Water') {
                        this.showWaterChart();
                    }
                }
            }
        },
        safetyMap: {
            immediate: false,
            deep: true,
            handler: function(newVal, oldVal) {
                if(typeof this.simpleMap !== $_TYPE.UNDEF) {
                    if(this.selectedRealtimeTab === 'Safety') {
                        this.showSafetyChart();
                    }
                }
            }
        },
        accidentMap: {
            immediate: false,
            deep: true,
            handler: function(newVal, oldVal) {
                if(typeof this.simpleMap !== $_TYPE.UNDEF) {
                    if(this.selectedRealtimeTab === 'Accident') {
                        this.showAccidentChart();
                    }
                }
            }
        },
        selectedMarker: {
            immediate: false,
            handler(newVal, oldVal) {
                this.$eventBus.$emit("LiveTab:stop-livetab-phase");
            }
        },
    },
    computed: {
        ...mapGetters({
            selectedRealtimeTab: 'getSelectedRealtimeTab',
            selectedRealtimeSubTab: 'getSelectedRealtimeSubTab',
            safetyList: 'getSafetyList',
            accidentList: 'getAccidentList',
            airSpace: 'getAirSpace',
            airHjdSensorList: 'getAirHjdSensorList',
            rainfallList: 'getRainfallList',
            rainfallMap: 'getRainfallMap',
            waterQualityList: 'getWaterQualityList',
            airHjdMeta: 'getAirHjdMeta',
            waterLevelList: 'getWaterLevelList',
            covidSeoul: 'getCovidSeoul',
            covidGuNmMappingMap: 'getCovidGuNmMappingMap',
            dongRainfallInfo:'getDongRainfallInfo',
            gripSimpleMap: 'getSimpleMap',
        }),
        safetyMap(){
            let safetyMap = {};
            this.safetyList.forEach((d)=>{
                for(let key in $_ADM.LEGDONG_NM_MAP){
                    if(d.address.indexOf(key) >= 0){
                        let legdongCd = $_ADM.LEGDONG_NM_MAP[key];
                        if(typeof safetyMap[legdongCd] === $_TYPE.UNDEF) {
                            safetyMap[legdongCd] = {
                                legdongNm: key,
                                calamityCount: 0,	//재난
                                fireCount: 0,	    //화재
                                rescueCount: 0,	    //구조
                                aidCount: 0,	    //구급
                            };
                        }
                        switch(d.safetyCategoryCd) {
                            case '0' : safetyMap[legdongCd].calamityCount++; break;
                            case '1' : safetyMap[legdongCd].fireCount++; break;
                            case '2' : safetyMap[legdongCd].rescueCount++; break;
                            case '3' : safetyMap[legdongCd].aidCount++; break;
                        }
                    }
                }
            });
            return safetyMap;
        },
        accidentMap(){
            let accidentMap = {};
            this.accidentList.forEach((d)=>{
                for(let key in $_ADM.LEGDONG_NM_MAP){
                    if(d.val4.indexOf(key) >= 0){
                        let legdongCd = $_ADM.LEGDONG_NM_MAP[key];
                        if(typeof accidentMap[legdongCd] === $_TYPE.UNDEF) {
                            accidentMap[legdongCd] = {
                                legdongNm: key,
                                trafficCount: 0,        //사고
                                constructionCount: 0,   //공사
                                eventCount: 0,          //행사
                                cartroubleCount: 0,     //통제
                            };
                        }
                        switch(d.val2) {
                            case '1' : accidentMap[legdongCd].trafficCount++; break;
                            case '2' : accidentMap[legdongCd].constructionCount++; break;
                            case '3' : accidentMap[legdongCd].eventCount++; break;
                            case '5' : accidentMap[legdongCd].cartroubleCount++; break;
                        }
                    }
                }
            });
            return accidentMap;
        },
        airHjdSensorMap: function() {
            return gripUtil.toDict(this.airHjdSensorList, 'addongHjbCd');
        },
    },
    created() {
        this.$eventBus.$on("SimpleMap::completed-simple-map-draw", (gripSimpleMap)=>{
            this.$store.dispatch('SET_SIMPLE_MAP', gripSimpleMap);
            if(typeof this['show' + this.selectedRealtimeTab + 'Chart'] === 'function') {
                this['show' + this.selectedRealtimeTab + 'Chart']();
            }
        });

        // this.$eventBus.$on("SimpleMap::click-simple-map-area", ()=> {
        //     let tab = this.selectedRealtimeTab;
        //     let subTab = this.selectedRealtimeSubTab;
        //     let hrefURL = $_WC.cp + 'realtime?mCode='+tab;
        //     if(tab === 'Air' || tab === 'Water') {
        //         hrefURL += '&sCode='+ subTab;
        //     }
        //     if(tab === 'Covid'){
        //         hrefURL = $_WC.cp + 'covid'
        //     }
        //     location.href = hrefURL;
        // });

    },
    methods: {
        showSafetyChart(){
            this.initChart();
            // for (let legdongCd in $_ADM.LEGDONG_CENTER_MAP) {
            //     let lat = $_ADM.LEGDONG_CENTER_MAP[legdongCd].lat;
            //     let lng = $_ADM.LEGDONG_CENTER_MAP[legdongCd].lng;
            //     let dongNm = $_ADM.LEGDONG_CENTER_MAP[legdongCd].dongNm;
            //     let data = [0, 0, 0, 0];
            //     if (typeof this.safetyMap[legdongCd] !== $_TYPE.UNDEF) {
            //         let safety = this.safetyMap[legdongCd];
            //
            //         data = [safety.calamityCount, safety.fireCount, safety.rescueCount, safety.aidCount];
            //     }
            //     this.simpleMap.addBoxChart(this.groupName, lat, lng, this.boxChartColors, data, this.boxChartMaxVal, this.boxChartSize, true);
            //     this.simpleMap.addText(this.groupName, lat, lng, 10, "#ffffff", dongNm);
            // }

            for (let addongCd in $_ADM.ADDONG_CENTER_MAP) {
                let lat = $_ADM.ADDONG_CENTER_MAP[addongCd].lat;
                let lng = $_ADM.ADDONG_CENTER_MAP[addongCd].lng;
                let dongNm = $_ADM.ADDONG_CENTER_MAP[addongCd].dongNm;
                this.simpleMap.addText(this.groupName, lat, lng, 10, "#ffffff", dongNm);
            }
            // 심플맵 재난 마커 추가
            this.placeMarkers();
        },
        showAccidentChart(){
            this.initChart();
            // for(let legdongCd in $_ADM.LEGDONG_CENTER_MAP) {
            //     let lat = $_ADM.LEGDONG_CENTER_MAP[legdongCd].lat;
            //     let lng = $_ADM.LEGDONG_CENTER_MAP[legdongCd].lng;
            //     let dongNm = $_ADM.LEGDONG_CENTER_MAP[legdongCd].dongNm;
            //     let data = [0, 0, 0, 0];
            //     if(typeof this.accidentMap[legdongCd] !== $_TYPE.UNDEF) {
            //         let accident = this.accidentMap[legdongCd];
            //         data = [accident.trafficCount, accident.constructionCount, accident.eventCount, accident.cartroubleCount];
            //     }
            //     this.simpleMap.addBoxChart(this.groupName, lat, lng, this.boxChartColors, data, this.boxChartMaxVal, this.boxChartSize, true);
            //     this.simpleMap.addText(this.groupName, lat, lng, 10, "#ffffff", dongNm);
            // }
            for (let addongCd in $_ADM.ADDONG_CENTER_MAP) {
                let lat = $_ADM.ADDONG_CENTER_MAP[addongCd].lat;
                let lng = $_ADM.ADDONG_CENTER_MAP[addongCd].lng;
                let dongNm = $_ADM.ADDONG_CENTER_MAP[addongCd].dongNm;
                this.simpleMap.addText(this.groupName, lat, lng, 10, "#ffffff", dongNm);
            }
            // 심플맵 재난 마커 추가
            this.placeMarkersAccident();
        },
        showAirChart() {
            this.initChart();
            let airQaMeta = this.airHjdMeta[this.selectedRealtimeSubTab];
            if(this.selectedRealtimeSubTab === 'rain') {
                // 강우량
                for(let name in this.dongRainfallInfo) {
                    let lat = this.dongRainfallInfo[name].lttdVal;
                    let lng = this.dongRainfallInfo[name].lgtdVal;
                    let val = this.dongRainfallInfo[name].threeHourSum;
                    let qa = airQaMeta.levelFun.call(airLevel, val);

                    let fontSizes = [9, 9, 9];
                    let texts = ['강우량', val +''+ airQaMeta.unit, name];

                    this.simpleMap.addCirCle(this.groupName, lat, lng, 22, qa[3], 1, undefined);
                    this.simpleMap.addText(this.groupName, lat, lng, fontSizes, "#43494c", texts, -1.3, 0.1);
                }

                // 하천수위
                this.waterLevelList.forEach((d)=>{
                    let cd = d.val1;
                    if(typeof $_ADM.WATER_LEVEL_LOC_MAP[cd] !== $_TYPE.UNDEF) {
                        let lat = $_ADM.WATER_LEVEL_LOC_MAP[cd].lat;
                        let lng = $_ADM.WATER_LEVEL_LOC_MAP[cd].lng;
                        let name = d.val2;
                        let val = d.val6;
                        let limit = d.val8;
                        let qa = airLevel.waterLevel(val, limit);
                        let fontSizes = [9, 9, 9];
                        let texts = ['하천수위', val +'m', name];

                        this.simpleMap.addCirCle(this.groupName, lat, lng, 22, qa[3], 1, undefined);
                        this.simpleMap.addText(this.groupName, lat, lng, fontSizes, "#43494c", texts, -1.3, 0.1);
                    }
                });
            } else {
                if(!!this.airHjdSensorMap) {
                    for (let addongCd in $_ADM.ADDONG_CENTER_MAP) {
                        let lat = $_ADM.ADDONG_CENTER_MAP[addongCd].lat;
                        let lng = $_ADM.ADDONG_CENTER_MAP[addongCd].lng;
                        let dongNm = $_ADM.ADDONG_CENTER_MAP[addongCd].dongNm;
                        this.simpleMap.addText(this.groupName, lat, lng, 10, "#ffffff", dongNm);
                        let umdAir = this.airHjdSensorMap[addongCd];
                        if(!!umdAir) {
                            let val = umdAir[airQaMeta.valCol];
                            let qa = airQaMeta.levelFun.call(airLevel, val);
                            this.simpleMap.changePathColor(addongCd, qa[3]);
                        }
                    }
                }
            }
        },
        showWaterChart() {
            this.initChart();
            let waterQualityMap = gripUtil.toDict(this.waterQualityList, 'val4');
            for(let addongNm in $_ADM.ADDONG_NM_MAP) {
                let addongCd = $_ADM.ADDONG_NM_MAP[addongNm];
                let lat = $_ADM.ADDONG_CENTER_MAP[addongCd].lat;
                let lng = $_ADM.ADDONG_CENTER_MAP[addongCd].lng;

                let val = '';
                let qa = '';

                let waterInfo = waterQualityMap[addongNm];
                if(typeof waterInfo !== $_TYPE.UNDEF){
                    val = waterInfo[this.selectedRealtimeSubTab];
                    qa = airLevel.waterQuality(val, this.selectedRealtimeSubTab);
                }
                this.simpleMap.changePathColor(addongCd, qa[3]);
                this.simpleMap.addText(this.groupName, lat, lng, 10, "#ffffff", addongNm);
            }
        },
        showCovidChart() {
            this.initChart();
            if(typeof this.simpleMap !== $_TYPE.UNDEF) {
                for(let key in this.covidGuNmMappingMap){
                    let sggNm = this.covidGuNmMappingMap[key];
                    let standardCount = typeof this.covidSeoul.val27 !== $_TYPE.UNDEF ? Number(this.covidSeoul.val27) : 0;
                    let textSize = [10, 10];
                    let textColor = ['#ffffff', '#ffffff'];
                    if(this.covidGuNmMappingMap[key] !== '기타'){
                        let lat = $_ADM.GU_CENTER_MAP[sggNm].lat;
                        let lng = $_ADM.GU_CENTER_MAP[sggNm].lng;
                        if(typeof this.covidSeoul[key] !== $_TYPE.UNDEF){
                            let count = Number(this.covidSeoul[key]);
                            let fillColor = '#cccccc';
                            if(sggNm === '강남구') {
                                fillColor = '#ffd401';
                            } else {
                                if(count > standardCount){
                                    fillColor = '#ff7a79';
                                }
                            }
                            let text = [];
                            text.push(gripUtil.toCurrency(count));
                            text.push(sggNm);

                            this.simpleMap.changePathColor(escape(sggNm), fillColor);
                            this.simpleMap.addEllipse(this.groupName, lat, lng, 25, 8, 0, 2, "#376078", 0.4); // #688b9f
                            this.simpleMap.addText(this.groupName, lat, lng, textSize, textColor, text, undefined, 0.2);
                        }
                    }
                }
            }
        },
        initChart(){
            this.simpleMap.isDisplayDefaultText(false);
            this.simpleMap.changeAllPathDefaultColor();
            this.simpleMap.removeAllTextGroup();
            this.simpleMap.removeAllMarkerGroup();
            this.simpleMap.removeAllCircleGroup();
            this.simpleMap.removeAllChartGroup();
        },
        placeMarkers() {
            if (this.selectedRealtimeTab === 'Safety' && typeof this.gripSimpleMap !== $_TYPE.UNDEF && this.safetyList.length > 0) {

                this.safetyList.forEach(safety => {
                    // 완료된 데이터는 튕기기
                    if(safety.processStateCd === 100) return;
                    // 진행중인 데이터 마커 및 데이터 세팅
                    if (safety.wtmX && safety.wtmY) {
                        let latlng = naverMapUtil.convertWgs84Coords(safety.wtmY, safety.wtmX);
                        safety.lttdVal = latlng[0];
                        safety.lgtdVal = latlng[1];
                        let fileExt = '.png';
                        // 마커 gif로 변경 시 0 : 화재 , 1 : 화재
                        if(safety.safetyCategoryCd === '0' || safety.safetyCategoryCd === '1') {
                            fileExt = '.gif';
                        }
                        let markerImgUrl = $_WC.assets + 'img/marker/marker_safety_' + safety.safetyCategoryCd + fileExt;
                        let width = 20 ; //4
                        let height = 25 ; //5
                        width = width * ($_WC.viewScale <= 1 ? 1 : 2);
                        height = height * ($_WC.viewScale <= 1 ? 1  : 2);
                        let marker = this.gripSimpleMap.addMarker(this.safetyMarkerGroupKey, safety.lttdVal, safety.lgtdVal, markerImgUrl, width, height);
                        // safety.marker = this.makeMarker(this.selectedRealtimeTab , safety, () => {
                            //             this.$refs.safetyInfoWin.setRegisterNo(safety.registerNo);
                        //         }, 'marker_safety_' + safety.safetyCategoryCd + '.png', "img/marker/", $_NM.MARKER_W, $_NM.MARKER_H);

                        safety.marker = marker;
                        this.addMarkerMap(this.safetyMarkerGroupKey, marker);

                        // // 마커 클릭 이벤트
                        if (marker) {
                            marker.on('click', () => {
                                marker.eventX = d3.event.clientX + window.pageXOffset;
                                marker.eventY = d3.event.clientY + window.pageYOffset;
                                this.$store.dispatch('SET_SELECTED_MARKER', marker);
                                this.$refs.safetyInfoWin.setRegisterNo(safety.registerNo);
                            });
                        }
                    }
                });
            }
        },
        placeMarkersAccident() {
            if (this.selectedRealtimeTab === 'Accident' && typeof this.gripSimpleMap !== $_TYPE.UNDEF && this.accidentList.length > 0) {

                this.accidentList.forEach(accident => {
                    // 진행중인 데이터 마커 및 데이터 세팅
                    if (accident.lttdVal && accident.lgtdVal) {
                        let markerImgUrl = $_WC.assets + 'img/marker/marker_accident_' + accident.val2 + '.png';
                        let width = 20 ; //4
                        let height = 25 ; //5
                        width = width * ($_WC.viewScale <= 1 ? 1 : 2);
                        height = height * ($_WC.viewScale <= 1 ? 1  : 2);
                        let marker = this.gripSimpleMap.addMarker(this.accidentMarkerGroupKey, accident.lttdVal, accident.lgtdVal, markerImgUrl, width, height);
                        accident.marker = marker;
                        this.addMarkerMap(this.accidentMarkerGroupKey, marker);

                        // // 마커 클릭 이벤트
                        if (marker) {
                            marker.on('click', () => {
                                marker.eventX = d3.event.clientX + window.pageXOffset;
                                marker.eventY = d3.event.clientY + window.pageYOffset;
                                this.$store.dispatch('SET_SELECTED_MARKER', marker);
                                this.$refs.accidentInfoWin.setAccidentInfo(accident);
                            });
                        }
                    }
                });
            }
        },
        loadedSimplemapInfoHandle(content) {
            if(typeof this.selectedMarker !== 'undefined') {
                let winHeight = window.innerHeight;
                let winWidth = window.innerWidth;
                let eventY = this.selectedMarker.eventY;
                let eventX = this.selectedMarker.eventX;

                let topOffset = 0;
                let leftOffset = 0;
                if(eventY >= (winHeight / 2)) {
                    topOffset = 1;
                }
                if(eventX >= (winWidth / 2)) {
                    leftOffset = 1;
                }
                this.openWin(content, leftOffset, topOffset);
            }
        },
    },
    mixins: [simpleMapMixins, NaverMapMixin, gripSimpleMapMixins],
};
</script>
